import { IAppState } from "app/model"

export function getDefaultAppState(): IAppState {
  return {
    isInitializating: true,
    hasInitError: false,
    activeContext: null
  }
}
